import appConstants from '../constants/appConstants';
import checkCredentials from '../authentication/checkCredentials';
import getCurrentUser from '../authentication/getCurrentUser';
import getUser from '../authentication/getUser';

function getUserProfile(redirected, username, userId) {
  return new Promise((resolve, reject) => {
    checkCredentials(redirected).then(() => {
      const docClient = new AWS.DynamoDB.DocumentClient();

      let id;

      if (username) {
        id = username + '-us-east-1:' + userId;
      } else {
        id = localStorage.zmailUsername + '-us-east-1:' + localStorage.zmailUserId;
      }

      const params = {
        TableName: appConstants.USER_TABLE,
        KeyConditionExpression: 'id = :userId',
        ExpressionAttributeValues: { ':userId': id },
      };

      docClient
        .query(params)
        .promise()
        .then((response) => {
          if (response.Count == 1) {
            const data = response.Items[0];
            localStorage.zmailSchoolName = data.school;

            const currentUser =
              localStorage.zmailSuperUsername == null
                ? localStorage.zmailUsername
                : localStorage.zmailSuperUsername;
            if (!window.redirect) {
              getUsersObj(currentUser).then((usersObj) => {
                if (usersObj) {
                  data.SchoolUsers = usersObj.schoolUsers;
                }

                const currUser = username == null ? localStorage.zmailUsername : username;

                resolve(data);
              });
            }
          } else {
            reject(new Error('No User Found'));
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  });
}

function getAllUsers() {
  return new Promise((resolve, reject) => {
    AWS.config.credentials.get(function (err) {
      if (err) {
        console.log(err);
      } else if (localStorage.zcruitUserPoolId) {
        const userPoolId = localStorage.zcruitUserPoolId;
        const listGroupsParams = { UserPoolId: userPoolId };
        const cognito = new AWS.CognitoIdentityServiceProvider(...AWS.config.credentials);

        cognito.listGroups(listGroupsParams, function (err, data) {
          if (err) {
            reject(err);
          }
        });

        var listUsersParams = {
          UserPoolId: userPoolId,
        };

        cognito.listUsers(listUsersParams, function (err, data) {
          if (err) {
            reject(err);
          } else {
            const usersArr = data.Users;
            resolve(usersArr);
          }
        });
      } else {
        resolve(getCurrentUser());
      }
    });
  });
}

function getUsersObj(currentUser) {
  return new Promise((resolve, reject) => {
    if (localStorage.zcruitUserPoolId) {
      var listUsersInGroupParams = {
        UserPoolId: localStorage.zcruitUserPoolId,
        GroupName: 'SuperUser',
      };

      const cognito = new AWS.CognitoIdentityServiceProvider(...AWS.config.credentials);

      let superUsers = [];
      cognito.listUsersInGroup(listUsersInGroupParams, (err, data) => {
        if (err) {
          console.log(err);
        } else {
          const newSuperUsers = superUsers.concat(
            data.Users.map((user) => {
              return user.Username;
            })
          );

          superUsers = newSuperUsers;

          if (superUsers.indexOf(currentUser) > -1) {
            localStorage.zmailSuperUsername = currentUser;
            getAllUsers().then((schoolUsers) => {
              schoolUsers = schoolUsers.map((user) => {
                if (superUsers.indexOf(user.Username) > -1) {
                  user.SuperUser = true;
                } else {
                  user.SuperUser = false;
                }
                return user;
              });

              // filter out "Deleted" Users
              const newSchoolUsers = schoolUsers.filter((user) => user.Enabled);

              resolve({ schoolUsers: newSchoolUsers });
            });
          } else {
            resolve({
              schoolUsers: [],
            });
          }
        }
      });
    } else {
      resolve(getCurrentUser());
    }
  });
}

export default getUserProfile;



// WEBPACK FOOTER //
// ./src/userFunctions/getUserProfile.js